<template>
	<acquisit-button class="acquisit-signature-document-button"
	                 :icon="icon"
	                 :color-container="colorContainer"
	                 :color-context-safe="false"
	                 icon-position="left"
	                 type="flat"
	                 bordered
	                 :href="href"
	                 target="_blank">
		<span class="file-labels">
		    <span class="label">
			    <acquisit-string :source="label" v-if="label" />
			    <slot name="label"></slot>
		    </span>
		    
		    <span class="filename">
			    {{ filename }}
		    </span>
	    </span>
	</acquisit-button>
</template>

<script setup lang="ts">
	import { useColor, useColorProps } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/helpers'
	import type { UILabel } from '@Visma-Real-Estate-Solutions/acquisit-ui-vue/library'
	import { computed, type PropType } from 'vue'
	import { getFilenameFromUrl } from '@/lib/functions.ts'
	
	const props = defineProps({
		...useColorProps(),
		
		href: {
			type: String,
			required: true
		},
		
		label: {
			type: [String, Object] as PropType<UILabel>,
			required: false,
			default: undefined
		},
		
		icon: {
			type: String,
			required: false,
			default: 'files/file'
		},
	})
	
	const color = useColor(props)
	
	const filename = computed(() => getFilenameFromUrl(props.href))
</script>

<style lang="scss">
    @use '@/assets/mixins.scss' as m;
    
    .acquisit-signature-document-button {
	    .flat-wrapper {
		    justify-content: flex-start;
		    align-items: flex-start;
		    
		    .icon {
			    margin-top: 1px !important;
		    }
	    }
	    
	    .file-labels {
		    
		    .label {
			    font-weight: 600;
			    
			    .acquisit-string {
				    font: inherit;
				    font-size: 1rem;
			    }
		    }
		    
		    .filename {
			    opacity: 0.7;
		    }
	    }
    }
</style>